const AADHAAR_MOBILE_KEYS = [
  "mobile",
  "mobileNumber",
  "mobile_number",
  "phone",
  "phoneNumber",
  "registeredMobile",
  "mobileNo",
  "aadhaar_mobile",
  "aadhaarMobile",
  "maskedMobile",
  "maskedMobileNumber",
];

/**
 * fundswalla.in wraps KYC as:
 * { success, data: { responseCode, responseMessage, data? / profile fields } }
 * or flat: { responseCode, responseMessage, data, referenceId }
 */
export const normalizeKycApiResponse = (raw) => {
  if (!raw || typeof raw !== "object") return {};

  if (raw.responseCode || raw.responseMessage) {
    return {
      responseCode: String(raw.responseCode || ""),
      responseMessage: raw.responseMessage || raw.message || "",
      referenceId: raw.referenceId || "",
      data: raw.data || null,
      success: raw.success,
      status: raw.status,
      failed: raw.failed,
    };
  }

  const inner = raw.data;
  if (inner && typeof inner === "object") {
    const responseCode = String(inner.responseCode || raw.responseCode || "");
    const responseMessage =
      inner.responseMessage ||
      inner.message ||
      raw.responseMessage ||
      raw.message ||
      inner.error ||
      "";
    const referenceId = inner.referenceId || raw.referenceId || "";

    if (
      inner.data &&
      typeof inner.data === "object" &&
      (inner.data.name ||
        inner.data.documentType ||
        inner.data.firstName ||
        inner.data.fullName ||
        inner.data.status ||
        inner.data.pan)
    ) {
      return {
        responseCode,
        responseMessage,
        referenceId,
        data: inner.data,
        success: raw.success,
        status: raw.status,
      };
    }

    if (
      inner.name ||
      inner.documentType ||
      inner.dateOfBirth ||
      inner.firstName ||
      inner.fullName ||
      inner.pan ||
      String(inner.status || "").toUpperCase() === "VALID"
    ) {
      const {
        responseCode: _rc,
        responseMessage: _rm,
        referenceId: _ri,
        message: _msg,
        error: _err,
        ...profile
      } = inner;
      return {
        responseCode,
        responseMessage,
        referenceId,
        data: Object.keys(profile).length ? profile : null,
        success: raw.success,
        status: raw.status,
      };
    }

    return {
      responseCode: responseCode || String(inner.status || raw.status_code || ""),
      responseMessage,
      referenceId,
      data: null,
      success: raw.success,
      status: raw.success === false ? false : raw.status,
    };
  }

  return {
    responseCode: String(raw.responseCode || raw.status_code || ""),
    responseMessage: raw.responseMessage || raw.message || raw.error || "",
    referenceId: raw.referenceId || "",
    data: null,
    success: raw.success,
    status: raw.status,
    failed: raw.failed,
  };
};

export const normalizeAadhaarMobile = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  const digits = raw.replace(/\D/g, "");
  if (digits.length >= 10) return digits.slice(-10);
  if (digits.length > 0) return digits;

  return raw;
};

export const pickAadhaarMobileFromObject = (obj) => {
  if (!obj || typeof obj !== "object") return "";

  for (const key of AADHAAR_MOBILE_KEYS) {
    const normalized = normalizeAadhaarMobile(obj[key]);
    if (normalized) return normalized;
  }

  return "";
};

/** Mobile can live on profile, wrapper, or nested sibling of profile.data */
export const extractAadhaarMobileFromResponse = (raw) => {
  if (!raw || typeof raw !== "object") return "";

  const normalized = normalizeKycApiResponse(raw);
  const fromProfile = pickAadhaarMobileFromObject(normalized.data);
  if (fromProfile) return fromProfile;

  const inner = raw.data;
  if (inner && typeof inner === "object") {
    const fromInner = pickAadhaarMobileFromObject(inner);
    if (fromInner) return fromInner;
  }

  return pickAadhaarMobileFromObject(raw);
};

export const parseAadhaarVerifyResponse = (raw) => {
  const normalized = normalizeKycApiResponse(raw);
  const profile = normalized.data ? { ...normalized.data } : {};
  const mobile = extractAadhaarMobileFromResponse(raw);

  if (mobile && !profile.mobile) {
    profile.mobile = mobile;
  }

  return {
    responseCode: normalized.responseCode,
    responseMessage: normalized.responseMessage,
    referenceId: normalized.referenceId,
    profile,
    mobile,
  };
};
